export default __webpack_public_path__ + "static/media/bronze.dfda15fa.svg";